import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { Fetch } from "../../../shared/Fetch";
import { JVDate } from "../../../shared/JVDate";
import { IUsersDropdown, ICompanyMastDropdown, IBranchMastDropdown, ITeamsDropdown } from "../../../models/IDropdown";
import { JVDropdown } from "../../../shared/JVDropdown";
import { useEffect, useState } from "react";
import { ILogin } from "../../../models/Login";
import { JVCheckbox } from "../../../shared/JVCheckbox";
import { MultiSelect } from "primereact/multiselect";
import { Dropdown } from "primereact/dropdown";

export interface IRevenueRepFilter {
    fromDate?: Date | null,
    toDate?: Date | null,
    company?: number | null,
    branch?: number[] | null,
    team?: number | null,
    login_ID?: number | null,
    activeUser?: boolean | null,
    isFilter?: number | null,
    user_Status?: boolean | null,
    frequency?: number | null,
    exclude_From_Report?: boolean | null,
    agreegate_Report?: boolean | null,
    rev_P_L?: boolean | null,
    p_Rev_P_L?: boolean | null,
}

export const EmptyRecRepFilter: IRevenueRepFilter = {
    fromDate: new Date,
    toDate: new Date,
    company: null,
    branch: null,
    team: null,
    login_ID: null,
    // activeUser:null,
    isFilter: null,
    user_Status: null,
    frequency: null,
    exclude_From_Report: null,
    agreegate_Report: null,
    rev_P_L: null,
    p_Rev_P_L: null,
}

const profitLoss = [
    { name: "--SELECT--", value: null },
    { name: "Profit", value: true },
    { name: "Loss", value: false }
];


interface Iprops {
    revenueFilter: IRevenueRepFilter,
    setRevenueFilter: (revenueFilter: IRevenueRepFilter) => void,
    showNormalUsers: boolean,
    showRecHeadUsers: boolean,
    showSalesHeadUsers: boolean,
}

export const Filter = (props: Iprops) => {
    const [users, setUsers] = useState<Array<IUsersDropdown>>();
    const [recHead, setRecHead] = useState<Array<IUsersDropdown>>();
    const [salesHead, setSalesHead] = useState<Array<IUsersDropdown>>();
    const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();
    const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();
    const [team, setTeam] = useState<Array<ITeamsDropdown>>();
    const [excel, setExcel] = useState<boolean>(false);
    const [excelNum, setExcelNum] = useState<number | null>(null);
    const [selectedBranch, setSelectedBranch] = useState<Array<number>>([]);
    const [selectedTeam, setSelectTeam] = useState<any | null>(null);
    const [selectedUser, setSelectedUser] = useState<any | null>(null);
    const [selectedRecHead, setSelectedRecHead] = useState<any | null>(null);
    const [selectedSalesHead, setSelectedSalesHead] = useState<any | null>(null);


    const { control, handleSubmit, reset, watch } = useForm<IRevenueRepFilter>({
        defaultValues: props.revenueFilter,
        shouldFocusError: false
    });
    const recruiters_Status = [
        { label: "-- SELECT --", status: null },
        { label: 'Active', status: true },
        { label: 'Inactive', status: false },
    ]

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const loadUsers = async (branch: number[] | null | undefined, company: number | null | undefined) => {
        let queryParameter = null;
        if (branch && branch.length > 0 && branch[0] != 0) {
            queryParameter = branch.map(b => `branch_ID=${b}`).join("&");
        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        }

        const response = await Fetch("Report_Revenue/getUsers", "GET", null, `userType=1&${queryParameter}`, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setUsers(data);
        }
    }

    const loadRecHeads = async (branch: number[] | null | undefined, company: number | null | undefined) => {
        let queryParameter = null;
        if (branch && branch.length > 0 && branch[0] != 0) {
            queryParameter = branch.map(b => `branch_ID=${b}`).join("&");
        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        }

        const response = await Fetch("Report_Revenue/getUsers", "GET", null, `userType=3&${queryParameter}`, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setRecHead(data);
        }
    }

    const loadSalesHeads = async (branch: number[] | null | undefined, company: number | null | undefined) => {
        let queryParameter = null;
        if (branch && branch.length > 0 && branch[0] != 0) {
            queryParameter = branch.map(b => `branch_ID=${b}`).join("&");
        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        }

        const response = await Fetch("Report_Revenue/getUsers", "GET", null, `userType=2&${queryParameter}`, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setSalesHead(data);
        }
    }



    const loadBranches = async (company?: number | null | undefined) => {
        let queryParam = company ? `company_id=${company}` : null;
        let endPoint = loginObj.id === 1346 ? "allBranches" : "reqBranchList";

        const response = await Fetch(`Dropdown/${endPoint}`, "GET", null, queryParam, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranches(data);
        }
    }
    const loadCompanies = async () => {
        let endPoint = loginObj.id === 1346 ? "company" : "reqCompanyList";

        const response = await Fetch(`Dropdown/${endPoint}`, "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompanies(data);
        }
    }

    // const loadTeam = async (branch: number[] | null | undefined, company: number | null | undefined) => {
    //     let queryParameter = null;
    //     if (branch && branch.length > 0 && branch[0] != 0) {
    //         //            queryParameter = `branch_ID=${branch}`;
    //         queryParameter = branch.map(b => `branch_ID=${b}`).join("&");

    //     } else if (company != 0 && company != null) {
    //         queryParameter = `company_ID=${company}`;
    //     }

    //     const response = await Fetch("Dropdown/teamsByBranches", "GET", null, queryParameter, null);
    //     if (response) {
    //         const data: Array<ITeamsDropdown> = await response.json();
    //         const emptyData = {
    //             team_ID: 0,
    //             team_Name: "-- SELECT --"
    //         };
    //         data.unshift(emptyData);
    //         setTeam(data);
    //     }
    // }

    useEffect(() => {
        loadUsers([], 0);
        loadCompanies();
        loadBranches();
        // loadTeam([], 0);
    }, []);

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "company") {
                if (value.company != 0) {
                    loadBranches(value.company);
                    loadUsers([], value.company);
                    loadRecHeads([], value.company);
                    loadSalesHeads([], value.company);
                } else {
                    loadBranches();
                    if (control._formValues.branch != 0) {
                        loadUsers(control._formValues.branch, 0);
                        loadRecHeads(control._formValues.branch, 0);
                        loadSalesHeads(control._formValues.branch, 0);
                    } else if (control._formValues.branch == 0) {
                        loadUsers([], 0);
                        loadRecHeads([], 0);
                        loadSalesHeads([], 0);
                    }
                }
            }

            if (name === "branch") {
                if (value.branch != null) {
                    loadUsers([], 0);
                    loadRecHeads([], 0);
                    loadSalesHeads([], 0);
                } else {
                    if (control._formValues.company != 0) {
                        loadUsers([], control._formValues.company);
                        loadRecHeads([], control._formValues.company);
                        loadSalesHeads([], control._formValues.company);
                    } else if (control._formValues.company == 0 && control._formValues.team == 0) {
                        loadUsers([], 0);
                        loadRecHeads([], 0);
                        loadSalesHeads([], 0);
                    }
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch]);


    const searchToDB = async (body: IRevenueRepFilter) => {
        // onHide();
        let filterData: any = body;
        let emptyFilter: any = EmptyRecRepFilter;
        for (let key in filterData) {
            if (filterData[key] === "-- SELECT --" || filterData[key] === 0) {
                filterData[key] = emptyFilter[key];
            }
        }
        body = filterData;
        props.setRevenueFilter(body);
    }

    // const onHide = () => {
    //     props.hideDialog();
    // }

    function onSubmit(data: IRevenueRepFilter) {
        let newDate = new Date;
        if (data.fromDate?.toDateString() !== newDate.toDateString() || (data.company !== null && data.company !== 0) || (data.branch !== null && selectedBranch.length > 0) || (data.team !== null && data.team !== 0) || (data.login_ID !== null && data.login_ID !== 0)) {
            data.isFilter = 1;
        } else {
            data.isFilter = null;
        }
        if (selectedBranch.length > 0) {
            data.branch = selectedBranch
        }
        delete data.frequency;
        data.login_ID = selectedUser;
        searchToDB(data);
    }
    useEffect(() => {
        if (selectedBranch.length > 0) {
            loadUsers(selectedBranch, 0); // Pass the entire array
        }
    }, [selectedBranch]);

    return (
        // <Dialog visible={props.open} style={{ width: '80vw' }} header="Search Recruiter Efficiency" modal className="p-fluid" onHide={onHide}>
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

            <JVDate maxDate={new Date} column={6} label="From Date" control={control} name="fromDate" />
            <JVDate maxDate={new Date} column={6} label="To Date" control={control} name="toDate" />
            <JVDropdown column={6} label="Company" control={control} name="company" options={companies} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company" />
            <div className="field col-2 md:col-2">
                <p>Branch</p>
                <MultiSelect className="" style={{ height: "37px", marginTop: "-10px" }} value={selectedBranch} onChange={(e) => setSelectedBranch(e.value)} options={branches} optionValue="branch_ID" optionLabel="branchName" display="chip" filter placeholder="Select Branches" />
            </div>
            {/* <div className="field col-2 md:col-2">
                <p>Team</p>
                <Dropdown value={selectedTeam} style={{ height: "37px", marginTop: "-10px" }} onChange={(e) => { setSelectTeam(e.value); }} options={team} optionLabel="team_Name" placeholder="Select Team" optionValue="team_ID" filter />
            </div> */}
            {props.showNormalUsers === true && <div className="field col-2 md:col-2">
                <p>Users</p>
                <Dropdown value={selectedUser} style={{ height: "37px", marginTop: "-10px" }} onChange={(e) => { setSelectedUser(e.value); }} options={users} optionLabel="user_Name" placeholder="Select Recruiter" optionValue="login_ID" filter />
            </div>}
            {props.showRecHeadUsers === true && <div className="field col-2 md:col-2">
                <p>Recruiter Head</p>
                <Dropdown value={selectedRecHead} style={{ height: "37px", marginTop: "-10px" }} onChange={(e) => { setSelectedRecHead(e.value); }} options={recHead} optionLabel="user_Name" placeholder="Select Recruiter" optionValue="login_ID" filter />
            </div>}
            {props.showSalesHeadUsers === true && <div className="field col-2 md:col-2">
                <p>Sales Head</p>
                <Dropdown value={selectedSalesHead} style={{ height: "37px", marginTop: "-10px" }} onChange={(e) => { setSelectedSalesHead(e.value); }} options={salesHead} optionLabel="user_Name" placeholder="Select Recruiter" optionValue="login_ID" filter />
            </div>}
            <JVDropdown column={6} label="Revenue Profit / Loss" control={control} name="rev_P_L" options={profitLoss} optionLabel="name" optionValue="value" placeholder="Select Status" />
            <JVDropdown column={6} label="Projected Revenue Profit / Loss" control={control} name="p_Rev_P_L" options={profitLoss} optionLabel="name" optionValue="value" placeholder="Select Status" />
            <div style={{ margin: '10px 0', width: '100%' }}></div>
            <div className="col-12 md:col-12" style={{ display: "flex", gap: "10px", marginTop: "10px", flexWrap: "nowrap" }}>
                <Button className="field" label="SEARCH" type="submit" style={{ height: "30px" }} />
                <Button className="field p-button-outlined" label="CLEAR" style={{ height: "30px" }} onClick={() => { reset(EmptyRecRepFilter); setExcel(false); setExcelNum(null); setSelectedBranch([]); setSelectTeam(null); setSelectedUser(null) }} type="button" />
            </div>
        </form>
    );
}